import { gql } from '@apollo/client';

export const V2FindAndCountAssets = gql`
  query V2FindAndCountAssets($where: V2AssetWhereInput!) {
    v2FindAndCountAssets(where: $where) {
      count
    }
  }
`;

export const v2FindAssetsByStatusTransition = (output: string) => gql`
  query v2FindAssetsByStatusTransition(
    $where: V2AssetStatusTransitionWhereInput!
    $orderBy: [V2AssetStatusTransitionOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
      v2FindAssetsByStatusTransition(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      ${output}
    }
  }
`;

export const COUNT_JAMF_ASSETS_V2 = gql`
  query V2FindAndCountAssets($organizationId: String!) {
    v2FindAndCountAssets(
      where: {
        organizationId: { equals: $organizationId },
        jamfId: { not: null },
        deletedAt: { equals: null }
      }
    ) {
      count
    }
  }
`;

export const GET_JAMF_ASSETS_V2 = gql`
  query v2FindAssets(
    $organizationId: String!,
    $skip: Int,
    $take: Int
  ) {
    v2FindAssets(
      where: {
        organizationId: { equals: $organizationId },
        jamfId: { not: null },
        deletedAt: { equals: null }
      },
      skip: $skip,
      take: $take
    ) {
      id
      assetNumber
      serialNumber
      make
      model
      jamfId
      status
      updatedAt
    }
  }
`;
